export default __webpack_public_path__ + "static/media/designer-news.6b3e4d88.svg";